import React, { Component } from 'react'
import axios from '~/data/http/axios'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import i18n from '~/i18n'
import WysiwygEditor from '~/pages/cp/templates/add/dragDrop/rightTools/elementEditor/components/wysiwyg'
import textFunctions from '~/Classes/textFunctions'
class Switcher extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {},
            form: JSON.parse(JSON.stringify(this.props.form))
        }
        this.save = this.save.bind(this)
        this.updateField = this.updateField.bind(this)
        this.checkForm = this.checkForm.bind(this)
    }

    buildForm() {
        switch (this.props.step) {
            case 1:
                return (
                    <div>
                        <h4 className='mar-b25'>{i18n.t('form:step2.header')}</h4>

                        <Select
                            name='onCreate'
                            value={this.state.form.options.onCreate}
                            data={[
                                { label: i18n.t('form:step2.redirect'), value: 'redirect' },
                                { label: i18n.t('form:step2.message'), value: 'message' },
                                { label: i18n.t('form:step2.hideForm'), value: 'hide' }
                            ]}
                            onChange={(ev) => this.updateField(ev, true)}
                            outerClassName='mar-b25'
                        />

                        {this.state.form.options.onCreate !== 'replace' && (
                            <div>
                                {this.state.form.options.onCreate == 'redirect' && (
                                    <TextInput
                                        id='redirect'
                                        mergeTags={true}
                                        mergeTagsModal={true}
                                        outerClassName='mar-b25'
                                        value={this.state.form.options.createRedirectUrl}
                                        error={this.state.errors.createRedirectUrl}
                                        placeholder={i18n.t('form:step2.url')}
                                        name='createRedirectUrl'
                                        onChange={(ev) => this.updateField(ev, true)}
                                    />
                                )}
                                {this.state.form.options.onCreate == 'message' && (
                                    <TextInput
                                        outerClassName='mar-b25'
                                        value={this.state.form.options.createMessage}
                                        error={this.state.errors.createMessage}
                                        placeholder={i18n.t('form:step2.success')}
                                        name='createMessage'
                                        onChange={(ev) => this.updateField(ev, true)}
                                    />
                                )}
                                {this.state.form.options.onCreate == 'hide' && (
                                    <div className='mar-b25'>
                                        <WysiwygEditor
                                            updateVal={(notUsed, theValue) => {
                                                this.updateField(
                                                    {
                                                        currentTarget: {
                                                            name: 'createMessage',
                                                            value: theValue
                                                        }
                                                    },
                                                    true
                                                )
                                            }}
                                            additionalTools={[
                                                'fontsizeselect',
                                                'fontselect',
                                                'bullist',
                                                'numlist',
                                                'mpzColorPicker'
                                            ]}
                                            AutomationId={null}
                                            hasWorkflowEmails={false}
                                            wysiwygMode='simple'
                                            wysiwygHeight='200px'
                                            standalone={true}
                                            name='createMessage'
                                            placeholder={i18n.t('form:step2.success')}
                                            error={this.state.errors.createHideMessage}
                                            value={this.state.form.options.createMessage}
                                            globalColours={[]}
                                            favoriteColors={[]}
                                        />
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )

            case 2:
                return (
                    <div>
                        <h4 className='mar-b25'>{i18n.t('form:step3.header')}</h4>

                        <Select
                            name='onUpdate'
                            value={this.state.form.options.onUpdate}
                            data={[
                                { label: i18n.t('form:step3.redirect'), value: 'redirect' },
                                { label: i18n.t('form:step3.message'), value: 'message' },
                                { label: i18n.t('form:step3.update'), value: 'update' }
                            ]}
                            onChange={(ev) => this.updateField(ev, true)}
                            outerClassName='mar-b25'
                        />

                        {this.state.form.options.onUpdate !== 'replace' &&
                            this.state.form.options.onUpdate !== 'update' && (
                                <div>
                                    {this.state.form.options.onUpdate == 'redirect' && (
                                        <TextInput
                                            id='redirect'
                                            mergeTags={true}
                                            mergeTagsModal={true}
                                            outerClassName='mar-b25'
                                            value={this.state.form.options.updateRedirectUrl}
                                            error={this.state.errors.updateRedirectUrl}
                                            placeholder={i18n.t('form:step3.url')}
                                            name='updateRedirectUrl'
                                            onChange={(ev) => this.updateField(ev, true)}
                                        />
                                    )}
                                    {this.state.form.options.onUpdate == 'message' && (
                                        <TextInput
                                            outerClassName='mar-b25'
                                            value={this.state.form.options.updateMessage}
                                            error={this.state.errors.updateMessage}
                                            placeholder={i18n.t('form:step3.success')}
                                            name='updateMessage'
                                            onChange={(ev) => this.updateField(ev, true)}
                                        />
                                    )}
                                </div>
                            )}
                    </div>
                )
            case 3:
                return
            case 4:
                return (
                    <div>
                        <h4 className='mar-b25'>{i18n.t('form:step5.header')}</h4>

                        <Select
                            name='onConfirm'
                            value={this.state.form.options.onConfirm}
                            data={[
                                { label: i18n.t('form:step5.landing'), value: 'landing' },
                                { label: i18n.t('form:step5.redirect'), value: 'redirect' }
                            ]}
                            onChange={(ev) => this.updateField(ev, true)}
                            outerClassName='mar-b25'
                        />

                        {this.state.form.options.onConfirm !== 'landing' && (
                            <div>
                                <TextInput
                                    outerClassName='mar-b25'
                                    value={this.state.form.options.confirmedRedirectUrl}
                                    error={this.state.errors.confirmedRedirectUrl}
                                    placeholder={i18n.t('form:step4.url')}
                                    name='confirmedRedirectUrl'
                                    onChange={(ev) => this.updateField(ev, true)}
                                />
                            </div>
                        )}
                    </div>
                )
        }
    }

    save() {
        var errors = this.checkForm()
        if (Object.keys(errors).length) return
        axios.put('/group/' + this.state.form.GroupId + '/form/' + this.state.form.id, this.state.form).then(() => {
            var step
            switch (this.props.step) {
                case 1:
                    if (
                        this.props.form.options.onCreate !== 'replace' &&
                        this.state.form.options.onCreate === 'replace'
                    )
                        step = 1
                    break
                case 2:
                    if (
                        this.props.form.options.onUpdate !== 'replace' &&
                        this.state.form.options.onUpdate === 'replace'
                    )
                        step = 2
                    break
                case 3:
                    break
                case 4:
                    if (
                        this.props.form.options.onConfirm !== 'replace' &&
                        this.state.form.options.onConfirm === 'replace'
                    )
                        step = 4
                    break
            }
            this.props.onSave(step)
        })
    }

    updateField(ev, options) {
        var form = this.state.form
        if (options) {
            if (ev.currentTarget.name === 'onCreate') {
                if (form.options.onCreate === 'hide' && ev.currentTarget.value == 'message') {
                    //if existing option is hide, convert html back to text for message
                    form.options.createMessage = textFunctions.checkForHtml(form.options.createMessage)
                }
            }

            form.options[ev.currentTarget.name] = ev.currentTarget.value
        } else {
            form[ev.currentTarget.name] = ev.currentTarget.value
        }
        this.setState(
            {
                form
            },
            this.checkForm
        )
    }

    checkForm() {
        var errors = {}
        var options = this.state.form.options
        switch (this.props.step) {
            case 1:
                if (options.onCreate === 'redirect') {
                    if (!options.createRedirectUrl) errors.createRedirectUrl = i18n.t('form:step2.errUrl')
                    else if (
                        options.createRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                        options.createRedirectUrl.toLowerCase().indexOf('https://') < 0
                    )
                        errors.createRedirectUrl = i18n.t('form:step2.errUrlHttp')
                }
                if (options.onCreate === 'message' && !options.createMessage)
                    errors.createMessage = i18n.t('form:step2.errMessage')
                break
            case 2:
                if (options.onUpdate === 'redirect') {
                    if (!options.updateRedirectUrl) errors.updateRedirectUrl = i18n.t('form:step2.errUrl')
                    else if (
                        options.updateRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                        options.updateRedirectUrl.toLowerCase().indexOf('https://') < 0
                    )
                        errors.updateRedirectUrl = i18n.t('form:step2.errUrlHttp')
                }
                if (options.onUpdate === 'message' && !options.updateMessage)
                    errors.updateMessage = i18n.t('form:step2.errMessage')
                break
            case 3:
                break
            case 4:
                if (options.onConfirm === 'redirect') {
                    if (!options.confirmedRedirectUrl) errors.confirmedRedirectUrl = i18n.t('form:step2.errUrl')
                    else if (
                        options.confirmedRedirectUrl.toLowerCase().indexOf('http://') < 0 &&
                        options.confirmedRedirectUrl.toLowerCase().indexOf('https://') < 0
                    )
                        errors.confirmedRedirectUrl = i18n.t('form:step2.errUrlHttp')
                }
                break
        }

        this.setState({
            errors
        })
        return errors
    }

    render() {
        return (
            <div>
                {this.buildForm()}
                <div className='quickFlex'>
                    <Button text={i18n.t('save')} className='button-primary mar-r10' onClick={this.save} />
                    <Button text={i18n.t('cancel')} onClick={this.props.onCancel} />
                </div>
            </div>
        )
    }
}

export default Switcher
